/**
 * Completeness of `matrix` answers. Answer shape: { [rowText]: columnValue }.
 * Only current non-empty question.matrixRows are checked, so stale keys from
 * renamed/removed rows do not count. An object without values is empty.
 */

export function isMatrixQuestion(question) {
  return !!question && question.type === 'matrix';
}

export function getMatrixRows(question) {
  const rows = Array.isArray(question && question.matrixRows) ? question.matrixRows : [];
  return rows.filter((row) => typeof row === 'string' ? row.trim() !== '' : row != null);
}

function hasValue(value) {
  if (value === undefined || value === null) return false;
  return String(value).trim() !== '';
}

export function getMissingMatrixRows(question, answer) {
  const rows = getMatrixRows(question);
  const map = answer && typeof answer === 'object' && !Array.isArray(answer) ? answer : {};
  return rows.filter((row) => !hasValue(map[row]));
}

export function isMatrixComplete(question, answer) {
  return getMissingMatrixRows(question, answer).length === 0;
}

/** True when a required matrix question blocks Next/Submit. */
export function matrixBlocksProgress(question, answer) {
  if (!isMatrixQuestion(question) || !question.required) return false;
  if (getMatrixRows(question).length === 0) return false;
  return !isMatrixComplete(question, answer);
}

export function matrixProgressMessage(question, answer) {
  if (!matrixBlocksProgress(question, answer)) return null;
  const missing = getMissingMatrixRows(question, answer).length;
  return `Оцените все пункты (осталось: ${missing})`;
}
